import { useQuery } from '@tanstack/react-query';

import { getPartnerOfContractorProject } from '@/features/projects/shared/api/get-partner-by-projects';

export const getPartnerOfContractorProjectKey = (projectId: number) =>
  ['partner-of-contractor-project', projectId] as const;

export const usePartnerOfContractorProject = ({
  projectId,
}: {
  projectId: number;
}) => {
  return useQuery({
    queryKey: getPartnerOfContractorProjectKey(projectId),
    queryFn: () => getPartnerOfContractorProject(projectId),
  });
};
